export default __webpack_public_path__ + "/dist/images/5330149.b4d3640800916352de0bf51db6cbe6f2.png";